import { Component, OnInit, inject } from '@angular/core';
import { Router, ActivatedRoute, RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-obrigado',
  standalone: true,
  imports: [CommonModule, RouterLink],
  template: `
    <div class="min-h-screen bg-[#111111] flex flex-col items-center justify-center px-4 text-center relative overflow-hidden">

      <!-- Hexagon background pattern -->
      <div class="absolute inset-0 hexagon-bg opacity-30 pointer-events-none"></div>

      <!-- Layout V1 (Original) -->
      <ng-container *ngIf="!isV2">
        <!-- Glow effect -->
        <div class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#FF5500]/10 rounded-full blur-[120px] pointer-events-none"></div>

        <!-- Logo -->
        <div class="mb-12 relative z-10">
          <img src="/images/logo-branca.svg" alt="beetrack Logo" class="h-10 w-auto mx-auto">
        </div>

        <!-- Content card -->
        <div class="relative z-10 max-w-2xl w-full bg-white/5 border border-white/10 rounded-2xl p-10 backdrop-blur-sm shadow-2xl">
          <!-- Icon checkmark -->
          <div class="w-20 h-20 bg-[#FF5500]/15 rounded-full flex items-center justify-center mx-auto mb-6 border border-[#FF5500]/30">
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#FF5500" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <path d="M20 6 9 17l-5-5"/>
            </svg>
          </div>

          <h1 class="text-4xl md:text-5xl font-bold text-white mb-4" style="font-family: 'Space Grotesk', sans-serif;">
            Obrigado!
          </h1>

          <p class="text-lg text-gray-300 mb-3">
            Recebemos suas informações com sucesso.
          </p>

          <p class="text-gray-400 mb-10 leading-relaxed">
            Um especialista da <span class="text-[#FF5500] font-semibold">beetrack</span> entrará em contato em breve para apresentar a melhor solução para o seu negócio.
          </p>

          <!-- Divider -->
          <div class="border-t border-white/10 mb-8"></div>
        </div>
      </ng-container>

      <!-- Layout V2 -->
      <ng-container *ngIf="isV2">

        <!-- Sim result layout (when queryParams present) -->
        @if (hasSimData) {
        <div class="relative z-10 flex flex-col items-center max-w-lg w-full">

          @if (isLargeOperation) {
          <!-- Large operation: custom enterprise message -->
          <div class="text-5xl mb-5">🏢</div>

          <div class="inline-flex items-center px-4 py-1.5 rounded-full border border-[#FF5500]/30 bg-[#FF5500]/10 text-[#FF5500] text-xs font-bold tracking-[0.15em] uppercase mb-6">
            Grande porte
          </div>

          <h1 class="text-3xl md:text-[38px] font-bold mb-3 leading-[1.2] text-center" style="font-family: 'Space Grotesk', sans-serif;">
            <span class="text-transparent bg-clip-text bg-gradient-to-r from-[#FF5500] to-[#FF8800]">{{ simEmpresa }}</span>
          </h1>

          <div class="w-full bg-[#1a1a1a] border border-[#FF5500]/30 rounded-2xl px-6 py-8 mb-8 text-center shadow-[0_0_50px_rgba(255,85,0,0.15)]">
            <p class="text-white text-lg font-semibold leading-relaxed mb-2">
              Sua operação é de grande porte!
            </p>
            <p class="text-gray-400 text-base leading-relaxed">
              Nossa equipe comercial irá preparar um orçamento personalizado para você. Um especialista entrará em contato em breve.
            </p>
          </div>

          }

          @if (!isLargeOperation) {
          <!-- Standard sim result -->
          <!-- Icon -->
          <div class="text-5xl mb-5">🎉</div>

          <!-- Pill -->
          <div class="inline-flex items-center px-4 py-1.5 rounded-full border border-[#FF5500]/30 bg-[#FF5500]/10 text-[#FF5500] text-xs font-bold tracking-[0.15em] uppercase mb-6">
            Simulação concluída
          </div>

          <!-- Heading -->
          <h1 class="text-3xl md:text-[38px] font-bold mb-3 leading-[1.2] text-center" style="font-family: 'Space Grotesk', sans-serif;">
            <span class="text-gray-400 block text-lg font-normal mb-1">Resultado para</span>
            <span class="text-transparent bg-clip-text bg-gradient-to-r from-[#FF5500] to-[#FF8800]">{{ simEmpresa }}</span>
          </h1>

          <p class="text-gray-500 text-sm mb-8 text-center">
            Um especialista já recebeu sua simulação e entrará em contato em breve.
          </p>

          <!-- Sim card -->
          <div class="w-full rounded-2xl overflow-hidden mb-8 shadow-[0_0_50px_rgba(255,85,0,0.2)]">
            <div class="bg-gradient-to-r from-[#FF5500] to-[#FF8800] px-6 py-4">
              <div class="text-white/70 text-[10px] font-bold uppercase tracking-[0.2em] mb-1">Investimento estimado / mês</div>
              <div class="text-white font-extrabold text-3xl tracking-tight">
                {{ formatCurrency(simValorMin) }} <span class="text-white/60 font-normal text-lg">até</span> {{ formatCurrency(simValorMax) }}
              </div>
            </div>
            <div class="bg-[#1a1a1a] border border-[#FF5500]/20 border-t-0 rounded-b-2xl px-6 py-5 text-left">
              <div class="grid grid-cols-2 gap-4 mb-2">
                <div>
                  <div class="text-gray-500 text-[10px] uppercase tracking-widest mb-1">Nome</div>
                  <div class="text-white font-bold text-xl">{{ simNome }}</div>
                </div>
                <div>
                  <div class="text-gray-500 text-[10px] uppercase tracking-widest mb-1">Colaboradores</div>
                  <div class="text-white font-bold text-xl">{{ simColaboradores }}</div>
                </div>
                <div>
                  <div class="text-gray-500 text-[10px] uppercase tracking-widest mb-1">Portas de câmara fria</div>
                  <div class="text-white font-bold text-xl">{{ simPortas }} {{ simPortas === 1 ? 'porta' : 'portas' }}</div>
                </div>
              </div>
              <div class="text-gray-600 text-xs mt-3">contrato 36 meses · sem custo de implantação</div>
            </div>
          </div>

          }

        </div>
        }

        <!-- Standard V2 layout (no sim data) -->
        @if (!hasSimData) {
        <div class="relative z-10 flex flex-col items-center max-w-2xl w-full">
          <div class="w-16 h-16 md:w-20 md:h-20 bg-gradient-to-br from-[#FFAD33] to-[#FF5500] rounded-full flex items-center justify-center mx-auto mb-6 shadow-[0_0_40px_rgba(255,85,0,0.6)] relative overflow-hidden">
            <div class="absolute inset-0 bg-gradient-to-tl from-black/20 to-transparent"></div>
            <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.9)" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="relative z-10">
              <path d="M20 6 9 17l-5-5"/>
            </svg>
          </div>
          <div class="inline-flex items-center px-4 py-1.5 rounded-full border border-[#FF5500]/30 bg-[#FF5500]/10 text-[#FF5500] text-xs font-bold tracking-[0.15em] uppercase mb-6">
            Formulário enviado com sucesso
          </div>
          <h1 class="text-4xl md:text-[44px] font-bold mb-4 leading-[1.2]" style="font-family: 'Space Grotesk', sans-serif;">
            <span class="text-white block">Obrigado pelo</span>
            <span class="text-transparent bg-clip-text bg-gradient-to-r from-[#FF5500] to-[#FF8800]">seu interesse!</span>
          </h1>
          <p class="text-gray-400 text-sm md:text-base mb-8 leading-relaxed max-w-sm">
            Em breve nossa equipe entrará em<br class="hidden sm:block"/>
            contato para apresentar a solução beetrack.
          </p>
        </div>
        }

        <a routerLink="/v2" style="color:#888; font-size:12px; margin-top:24px; background:none; border:none; display:block; text-align:center; cursor:pointer; text-decoration:none;">← Voltar para a página</a>

      </ng-container>

      <!-- Footer note -->
      <p class="relative z-10 mt-8 text-gray-600 text-sm">
        © {{ currentYear }} beetrack. Todos os direitos reservados.
      </p>
    </div>
  `,
  styles: [`
    .hexagon-bg {
      background-image: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M30 0l25.98 15v30L30 60 4.02 45V15z' fill-opacity='0.03' fill='%23FF5500' fill-rule='evenodd'/%3E%3C/svg%3E");
    }
  `]
})
export class ObrigadoComponent implements OnInit {
  currentYear = new Date().getFullYear();
  router = inject(Router);
  route = inject(ActivatedRoute);
  isV2 = false;
  hasSimData = false;
  isLargeOperation = false;
  simNome = '';
  simEmpresa = '';
  simPortas = 0;
  simColaboradores = 0;
  simValorMin = 0;
  simValorMax = 0;

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      if (this.router.url.includes('/obrigado')) {
        this.isV2 = true;

        if (params['valorMin']) {
          this.simNome = params['nome'] || '';
          this.simEmpresa = params['empresa'] || '';
          this.simPortas = +params['portas'] || 0;
          this.simColaboradores = +params['colaboradores'] || 0;
          this.simValorMin = +params['valorMin'] || 0;
          this.simValorMax = +params['valorMax'] || 0;
          this.hasSimData = true;
          this.isLargeOperation = this.simPortas > 50 || this.simColaboradores > 1000;

          if (typeof window !== 'undefined' && (window as any).fbq) {
            (window as any).fbq('track', 'Lead', {
              content_name: 'Simulador Pausa Térmica',
              content_category: 'Simulacao',
              value: this.simValorMin,
              currency: 'BRL'
            });
          }

          if (!this.isLargeOperation) {
            this.triggerConfetti();
          }
        }
      }
    });
  }

  formatCurrency(value: number): string {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(value);
  }

  private confettiStylesInjected = false;

  private injectConfettiStyles() {
    if (this.confettiStylesInjected) return;
    this.confettiStylesInjected = true;
    const style = document.createElement('style');
    style.textContent = `
      @keyframes confetti-fall {
        0%   { transform: translateY(-20px) rotate(0deg); opacity: 1; }
        100% { transform: translateY(110vh) rotate(720deg); opacity: 0; }
      }
      .confetti-piece {
        position: fixed;
        top: -20px;
        font-weight: bold;
        pointer-events: none;
        z-index: 9999;
        animation: confetti-fall linear forwards;
        user-select: none;
      }
    `;
    document.head.appendChild(style);
  }

  private triggerConfetti() {
    this.injectConfettiStyles();
    const symbols = ['$', 'R$', '$', 'R$', '$'];
    const colors = ['#25D366', '#4CAF50', '#FFD700', '#FFC107', '#FF5500', '#FF8800', '#32CD32'];

    for (let i = 0; i < 80; i++) {
      const delay = Math.random() * 1500;
      setTimeout(() => {
        const el = document.createElement('span');
        el.className = 'confetti-piece';
        el.textContent = symbols[Math.floor(Math.random() * symbols.length)];
        el.style.left = `${Math.random() * 100}vw`;
        el.style.color = colors[Math.floor(Math.random() * colors.length)];
        el.style.fontSize = `${14 + Math.random() * 18}px`;
        const duration = 2.5 + Math.random() * 2.5;
        el.style.animationDuration = `${duration}s`;
        document.body.appendChild(el);
        setTimeout(() => el.remove(), (duration + 0.2) * 1000);
      }, delay);
    }
  }
}

